import { render, staticRenderFns } from "./Proposition.vue?vue&type=template&id=163fc92e&scoped=true&lang=true&"
import script from "./Proposition.vue?vue&type=script&lang=js&"
export * from "./Proposition.vue?vue&type=script&lang=js&"
import style0 from "./Proposition.vue?vue&type=style&index=0&id=163fc92e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163fc92e",
  null
  
)

export default component.exports